import LoginPage from '../views/login/login.vue'

export default [
    {
        path: '/login',
        name: 'LoginPage',
        component: LoginPage
    }
]